import { render, staticRenderFns } from "./AssessmentPaymentData.vue?vue&type=template&id=df4dd3f4&scoped=true"
import script from "./AssessmentPaymentData.vue?vue&type=script&lang=js"
export * from "./AssessmentPaymentData.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPaymentData.vue?vue&type=style&index=0&id=df4dd3f4&prod&scoped=true&lang=css"
import style1 from "./AssessmentPaymentData.vue?vue&type=style&index=1&id=df4dd3f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4dd3f4",
  null
  
)

export default component.exports